import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-cyan-500/[0.09] via-slate-950 to-violet-500/[0.09] p-10 md:p-16"
        >
          <div className="absolute inset-0 grid-bg opacity-25" />
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-cyan-500/10 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-violet-500/10 blur-3xl" />

          <div className="relative flex flex-col lg:flex-row lg:items-center justify-between gap-8">
            <div className="max-w-2xl">
              <div className="eyebrow">/ Let's build</div>
              <h2 className="mt-4 font-display text-3xl md:text-5xl font-black tracking-tighter text-white">
                Stop firefighting infrastructure. <br />
                <span className="text-gradient">Start engineering outcomes.</span>
              </h2>
              <p className="mt-5 text-slate-300 max-w-xl">
                30-minute discovery call. Zero fluff. A senior engineer will map your
                platform gaps and quick wins the same day.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row lg:flex-col gap-3 shrink-0">
              <Link
                to="/contact"
                data-testid="cta-book-consult"
                className="group inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-cyan-400 text-slate-950 font-semibold hover:bg-cyan-300 transition shadow-[0_0_30px_rgba(0,229,255,0.35)]"
              >
                Book a consultation
                <ArrowUpRight size={17} className="group-hover:rotate-45 transition-transform" />
              </Link>
              <a
                href={COMPANY.phoneHref}
                className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-white/15 bg-white/[0.03] text-white font-medium hover:bg-white/[0.08] transition"
              >
                {COMPANY.phone}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
